import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import DataTable from "../DataTable/DataTable";
import { getUsedDetails } from "../../services/apiService";
import LoaderWithBackdrop from "../Loader/loader";

function Usage() {

    const userId = localStorage.getItem("userId") || "";
    const [usageDetails, setUsageDetails] = React.useState([]);
    const [page, setPage] = React.useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = React.useState<number>(25);
    const [totalCount, setTotalCount] = React.useState<number>(0);
    const [isLoading, setIsLoading] = React.useState<boolean>(false)
    React.useEffect(() => {
        fetchUsageDetails(page, rowsPerPage);
        // eslint-disable-next-line
    }, [page, rowsPerPage, userId]);

    // Fetch usage details from the API
    const fetchUsageDetails = async (page: number, rowsPerPage: number) => {
        setIsLoading(true);
        try {
            const response = await getUsedDetails('usage', userId, rowsPerPage, page + 1);
            setIsLoading(false);
            if (response && response.data) {
                setUsageDetails(response.data.data || []);
                setTotalCount(response.data.total || 0);
            } else {
                setUsageDetails([]);
                setTotalCount(0);
            }
        } catch (error) {
            setIsLoading(false);
            setUsageDetails([]);
            setTotalCount(0);
        }
    }
    // Define the columns for the DataTable
    const columns = [
        { id: 'avatar', label: 'Media Type', isAvatarText: true },
        { id: "source", label: "Source" },
        { id: "creditused", label: "Credit Used" },
        { id: "generatedon", label: "Generated on" },
    ];

    const rows = usageDetails
        .filter((item: any) => item.profileUrl && item.profileUrl !== "")
        .map((item: any) => {
            // Persona logic based on eventId
            let personaType = item.eventName;
            if (item.eventId === "684a5da3ed3f46be2271c921") {
                personaType = "Product Position";
            } else if (item.eventId === "683422b3227c23ad8919e8be" || item.eventId === "6834224e227c23ad8919e8bd" || item.eventId === "" || !item.eventId) {
                personaType = "Personas";
            }else if( item.eventId === "686e5c878abfae07b94e1b16"){
                personaType = "Short Film";
            }
            return {
                id: item.id,
                avatar: { url: item.profileUrl, fileName: item.filename || '', prompt: item.prompt || '' },
                source: personaType,
                creditused: item.creditsUsed ,
                generatedon: item.createdAt
                    ? new Date(item.createdAt).toLocaleString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                    }).replace(',', '')
                        .replace(/(\d{2}:\d{2})/, (match) => match.replace(':', ':'))
                    : '',
            };
        });

    // Pagination handle
    const handleChangePage = (event: unknown, newPage: number) => {
        console.log("Page changed to:", newPage);
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <Grid padding={2} item xs={12}
         sx={{
    padding: {
      xs: 0,    
      sm: 2,     
    },
  }}>
            {isLoading && <LoaderWithBackdrop open={isLoading} />}
            <Box>
                <Typography variant="h1" gutterBottom className="studioNavHeading">My Usage</Typography>
            </Box>
            <Box padding={2}>
                <DataTable
                    columns={columns}
                    rows={rows}
                    count={totalCount}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Box>
        </Grid>
    );
}
export default Usage;